var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autowarp"},[_c('h1',[_vm._v("您的登录存在异常,请尝试重新登录")]),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.jump}},[_vm._v("重新登录")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }